import { t } from 'i18next';
import CryptoJS from 'crypto-js';

export const FILTER_DAYS = [
  { value: "7days", label: "Last 7 Days" },
  { value: "1month", label: "1 Month" },
  { value: "custom", label: "Custom Range" },
];

export const PROJECT_STATUS = [
  { id: "3", label: t("yettostart") },
  { id: "0", label: t("InProgress") },
  { id: "1", label: t("Completed") },
  { id: "2", label: t("Cancelled") },
];

export const ROLE = [
  "/employee", "/project", "/todo", "/client", "/add-project",
  "/department", "/sub_depart", "/role-access", "/application-track",
  "/keystroke", "/Url-track", "/screen-shots", "/locations",
  "/attendence", "/timesheet", "/screen-interval", "/employee-device",
  "/time-off", "/subscription", "/schedule", "/case_tracking", "/employee-activity",
  "/white_list", "/overall-employee-report", "/task-report", "/project-report"
]




export const EncryptData = (data, crypto) => {
  const key = CryptoJS.enc.Utf8.parse(crypto.KEY);
  const iv = CryptoJS.enc.Utf8.parse(crypto.IV);
  const encrypted = CryptoJS.AES.encrypt(data?.toString(), key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted?.toString();
};

// deviceId.js
export function getDeviceId() {
  let deviceId = localStorage.getItem('deviceId');

  if (!deviceId) {
    deviceId = crypto.randomUUID(); // Generate a secure UUID
    localStorage.setItem('deviceId', deviceId);
  }

  return deviceId;
}
